import React from 'react';
import { Modal } from 'reactstrap';
import CloseIcon from 'mdi-react/CloseIcon';
import FormBuilder from './FormBuilder';
import { partial } from '../../../util/translation/translation';

const QuestionModal = ({ showModal, onClose, editableQuestion }) => {
  const qT = partial('question');
  const isEdit = !!editableQuestion;
  // Editing the event's own copy only changes this event; editing a
  // library question changes it for every event that adds it later
  const subtitle = !isEdit
    ? qT('newQuestionSubtitle')
    : editableQuestion.type === 'domain'
      ? qT('editDomainQuestionSubtitle')
      : qT('editLibraryQuestionSubtitle');

  return (
    <Modal
      modalClassName="question-modal"
      contentClassName="qm"
      isOpen={!!showModal}
      toggle={onClose}
      centered
    >
      <div className="qm-header">
        <div>
          <h2 className="qm-header__title" id="question-modal-title">
            {isEdit ? qT('edit') : qT('newQuestion')}
          </h2>
          <p className="qm-header__subtitle">{subtitle}</p>
        </div>
        <button
          type="button"
          className="qm-header__close"
          onClick={onClose}
          aria-label={qT('close')}
        >
          <CloseIcon size={20} />
        </button>
      </div>
      <FormBuilder setShowModal={onClose} editableQuestion={editableQuestion} />
    </Modal>
  );
};
export default QuestionModal;
